import {Box, Paper} from '@mui/material';
import React, {useCallback, useRef} from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import ContactForm from '../../forms/ContactForm';
import EndUserLocations from './EndUserLocations';
import NewOrExistingContact from './NewOrExistingContact';
import NewOrExistingEndUser from './NewOrExistingEndUser';
import Who from './Who';

const NewEndUser = ({onBack, onNext, session}) => {
  /** @type {({current: ContactForm})} */
  const formRef = useRef();

  const handleBack = useCallback(() => {
    onBack(
      session.selectedContact ?
        {type: NewOrExistingEndUser.type, id: NewOrExistingEndUser.type} :
        (
          session.selectedCompany ?
            {type: NewOrExistingContact.type, id: NewOrExistingContact.type} :
            {type: Who.type, id: Who.type}
        )
    )
  }, [onBack, session]);

  return (
    <>
      <Header>Create a New End User</Header>
      <Paper component={Box} padding={2}>
        <ContactForm
          ref={formRef}
          contact={{}}
          company={session?.selectedCompany ?? null}
          endUser={true}
          onSaved={(saved) => onNext(
            {type: EndUserLocations.type, id: EndUserLocations.type},
            {
              selectedEndUser: {
                id: saved.id,
                title: saved.title,
                first_name: saved.first_name,
                last_name: saved.last_name
              }
            }
          )}/>
      </Paper>
      <Controls
        onBack={handleBack}
        onNext={() => formRef.current.save()}
        nextLabel="Save New End User"
      />
    </>
  );
};

NewEndUser.type = 'NEW_END_USER';

export default NewEndUser;
